import { api } from './utils'

export interface IUploadServerAnswer {
	success: true
	isSlim: false
	message: string
}

export async function uploadSkin(base64: string): Promise<IUploadServerAnswer> {
	const request = await fetch(`${api}/cabinet/uploadSkin`, {
		method: 'POST',
		body: JSON.stringify({ skin: base64 })
	})

	return await request.json() as IUploadServerAnswer
}

export async function uploadCloak(base64: string): Promise<IUploadServerAnswer> {
	const request = await fetch(`${api}/cabinet/uploadCloak`, {
		method: 'POST',
		body: JSON.stringify({ cloak: base64 })
	})

	return await request.json() as IUploadServerAnswer
}

export async function removeSkin(): Promise<IUploadServerAnswer> {
	const request = await fetch(`${api}/cabinet/deleteSkin`)

	return await request.json() as IUploadServerAnswer
}

export async function removeCloak(): Promise<IUploadServerAnswer> {
	const request = await fetch(`${api}/cabinet/deleteCloak`)

	return await request.json() as IUploadServerAnswer
}
